import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChildWithSchool } from "../../utils/api/user/user.type";
import { AppStorage } from "../../utils/storage";

const initialState = AppStorage.getItem<ChildWithSchool>("child", {
  infos: undefined,
  school: undefined,
});
export const ChildSlice = createSlice({
  name: "child",
  initialState,
  reducers: {
    onSetInfos: (state, action: PayloadAction<ChildWithSchool["infos"]>) => {
      state.infos = action.payload;
      AppStorage.setItem("child", state);
    },
    onSetSchool: (state, action: PayloadAction<ChildWithSchool["school"]>) => {
      state.school = action.payload;
      AppStorage.setItem("child", state);
    },
    onSetInfosAndSchool: (state, action: PayloadAction<ChildWithSchool>) => {
      // console.log("user",action)
      state.infos = action.payload.infos;
      state.school = action.payload.school;
      AppStorage.setItem("child", state);
    },
    onCleanChild: (state) => {
      state.infos = null;
      state.school = null;
      AppStorage.setItem("child", state);
      AppStorage.clear();
    },
  },
});

export const { onSetInfos, onSetSchool, onSetInfosAndSchool, onCleanChild } =
  ChildSlice.actions;
export default ChildSlice.reducer;